module.exports = __webpack_public_path__ + "static/media/customer_bg.dfc3b91f.jpg";